import React from 'react';
import { MODEL_ROW_TITLE } from '../recs/useModelRow';
import './ModelRowStatus.css';

interface Props {
  status: 'loading' | 'error';
}

export default function ModelRowStatus({ status }: Props) {
  return (
    <section className="row">
      <h2 className="row__title">{MODEL_ROW_TITLE}</h2>
      <div className="model-row-status">
        {status === 'loading' ? (
          <span>Loading live recommendations from the just_watch model…</span>
        ) : (
          <span>
            AI engine unreachable — start it with <code>uv run just-watch-api</code> in <code>api/</code>.
          </span>
        )}
      </div>
    </section>
  );
}
